import React, { useContext, useState } from 'react'
import { Button, Box } from '@mui/material'
import { ModalContact } from './ModalContact'
import { LanguageContext } from './LanguageContext'

export const ContactusButton = () => {
  const { language } = useContext(LanguageContext)
  const isArabic = language === 'ar'
  const [open, setOpen] = useState(false)

  const label = isArabic ? 'تواصل معنا' : 'Contact Us'

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%',margin:'5px' }}>
      <Button
        onClick={() => setOpen(true)}
        sx={{
          height: '46px',
          padding: '0 26px',
          borderRadius: '14px',
          fontFamily: "'Cairo', sans-serif",
          fontWeight: 700,
          fontSize: '0.95rem',
          textTransform: 'none',
          background: 'linear-gradient(135deg, #4a7c3f, #6aad55)',
          color: '#fff',
          boxShadow: '0 6px 20px rgba(74,124,63,0.35)',
          transition: 'all 0.25s ease',
          '&:hover': {
            background: 'linear-gradient(135deg, #3d6b34, #5a9a47)',
            boxShadow: '0 10px 28px rgba(74,124,63,0.45)',
            transform: 'translateY(-2px)',
          },
        }}
      >
        {label}
      </Button>

      <ModalContact open={open} onClose={() => setOpen(false)} />
    </Box>
  )
}
